import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'
import {AccessRights} from 'constants'
import {Feature} from '../../../../features/constants'

export default class LeaveTimeDescriptionStrategy extends DescriptionStrategy {
    constructor({
        reportUrl = '',
        name = '',
    }) {
        super()

        this.params = {
            reportUrl,
            name,
        }

        this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
            hasSick: false,
            hasPTO: false,
        }

        this.userType = null


        this.onStatePropertyChanged('userRights', (userRights) => {
            if (userRights[AccessRights.MANAGE_PTO_AND_SICK] || userRights[AccessRights.MANAGE_USERS])
                this.userType = UserTypes.MANAGE_PTO_AND_AP
            else if (userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                this.userType = UserTypes.USER_WITH_MODIFY_OTHERS
            } else {
                this.userType = userRights[AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT
            }
        })
    }

    getHeader() {
        return messageResource.getMessage(this.params.name) + ' ' + messageResource.getMessage('report.common.report')
    }

    getDescription() {
        const sickFeatureEnabled = this.state.enabledFeatures[Feature.SDB]
        const ptoFeatureEnabled = this.state.enabledFeatures[Feature.PTO]
        const hasPTO = ptoFeatureEnabled && this.state.hasPTO
        const hasSick = sickFeatureEnabled && this.state.hasSick
        const userRights = this.state.userRights
        const isPersonalReport = !userRights[AccessRights.MANAGE_PTO_AND_SICK] && !userRights[AccessRights.MANAGE_USERS]
                                 && !userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]

        let balancesName
        let balancesDisabled
        if (isPersonalReport) {
            balancesName = hasPTO && hasSick ? messageResource.getMessage('dashboard.description.leavetime.both_balances') :
                           hasSick ? messageResource.getMessage('dashboard.description.leavetime.sick_balance') :
                           hasPTO ? messageResource.getMessage('dashboard.description.leavetime.pto_balance') : ''
            balancesDisabled = balancesName === ''
        }
        else {
            balancesName = sickFeatureEnabled && ptoFeatureEnabled ? messageResource.getMessage('dashboard.description.leavetime.both_balances') :
                           sickFeatureEnabled ? messageResource.getMessage('dashboard.description.leavetime.sick_balance') :
                           ptoFeatureEnabled ? messageResource.getMessage('dashboard.description.leavetime.pto_balance') : ''
            balancesDisabled = balancesName === ''
        }

        let firstParagraph
        let secondParagraph
        switch (this.userType) {
            case UserTypes.REGULAR_WITH_TT:
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.regular_with_tt.part1')
                if (!balancesDisabled) {
                    secondParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.regular_with_tt.part2', [balancesName])
                } else {
                    secondParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.regular_with_tt.part2.none_balance')
                }
                return this._createDescription(firstParagraph, secondParagraph)
            case UserTypes.REGULAR_WITHOUT_TT:
                return ''
            case UserTypes.MANAGE_PTO_AND_AP:
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.user_modify_or_ap.part1')
                if (!balancesDisabled) {
                    secondParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.user_modify_or_ap.part2', [balancesName])
                } else {
                    secondParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.user_modify_or_ap.part2.none_balance')
                }
                return this._createDescription(firstParagraph, secondParagraph)
            case UserTypes.USER_WITH_MODIFY_OTHERS:
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.user_submit_other_tt.part1')
                if (!balancesDisabled) {
                    secondParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.user_submit_other_tt.part2', [balancesName])
                } else {
                    secondParagraph = messageResource.getEscapedMessage('dashboard.description.leavetime.user_submit_other_tt.part2.none_balance')
                }
                return this._createDescription(firstParagraph, secondParagraph)
        }
    }


    _createDescription(first, second) {
        return '<div>' +
               '  <div class="firstParagraph">' + first + '</div>' +
               '  <div class="secondParagraph">' + second + '</div>' +
               '</div>'
    }

    getDetailsCallback() {
        openUserGuidePage('report-leaves-balances')
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }
}

const UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    MANAGE_PTO_AND_AP: 'UserWithManagePTOandAPPermissions',
    USER_WITH_MODIFY_OTHERS: 'UserWithSubmitOtherTTRight',
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/LeaveTimeDescriptionStrategy.js